import { usersService } from "../services";

const userLocalStorageKey = "GOP.user";
const userInfo = JSON.parse(localStorage.getItem(userLocalStorageKey));
const state = userInfo ? { status: { loggedIn: false }, userInfo } : { status: {}, userInfo: null };

const actions = {
    login({ commit }, { username, password }) {
        commit("loginRequest", { username });

        return usersService.login(username, password).then(
            response => {
                commit("loginSuccess", response);
                return response;
            },
            error => {
                commit("loginFailure", error);
                throw error;
            }
        );
    },
    loginWithSessionID({ commit }, { sessionID }) {

        return usersService.loginWithSessionID(sessionID).then(
            response => {
                commit("loginSuccess", response);
                return response;
            },
            error => {
                commit("loginFailure", error);
                throw error;
            }
        );
    },
    useLoginToken({ commit }, loginToken) {
        return usersService.useLoginToken(loginToken).then(
            response => {
                commit("loginSuccess", response);
                return response;
            },
            error => {
                commit("loginFailure", error);
                throw error;
            }
        )
    },
    logout({ commit }, { clientOnly, sessionID }) {
        usersService.logout(clientOnly, sessionID);
        commit("logout");
    },
    windowsAuthenticationLogin({ commit }) {
        return usersService.windowsAuthenticationLogin().then(response => {
            if (response.IsLoggedIn)
                commit("loginSuccess", response);
            return response
        });
    },
    updateOptions({ commit }, { blo }) {
        commit("updateOptions", blo);
    },
    updateBackgroundColor({ commit }, backgroundColor) {
        commit("updateBackgroundColor", backgroundColor)
    },
    toggleHelpButton({ commit }) {
        commit("toggleHelpButton");
    },
};

const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.userInfo = user;
    },
    loginSuccess(state, loginResponse) {
        state.status = { loggedIn: true };
        state.userInfo = loginResponse.UserInfo;
        state.sessionID = loginResponse.SessionID;
        state.showHelpButton = false;
    },
    loginFailure(state) {
        state.status = {};
        state.userInfo = null;
    },
    logout(state) {
        state.status = {};
        state.userInfo = null;
        state.sessionID = null;
    },
    updateOptions(state, blo) {
        Object.keys(state.userInfo.UserOptions).forEach(propName => {
            state.userInfo.UserOptions[propName] = blo[propName];
        });
        localStorageSetItem(state.userInfo)
    },
    updateBackgroundColor(state, backgroundColor) {
        state.userInfo.AppCDBBodyBgColor = backgroundColor
        localStorageSetItem(state.userInfo)
    },
    toggleHelpButton(state) {
        state.showHelpButton = !state.showHelpButton;
    }
};

const getters = {
    isAuthenticated: state => state.status.loggedIn,
    permissions: state => state.userInfo && state.userInfo.UserPermissions ? state.userInfo.UserPermissions : [],
    sessionID: state => state.sessionID,
    showHelpButton: state => state.showHelpButton,
    backgroundColor: state => state.userInfo && state.userInfo.AppCDBBodyBgColor
}

function localStorageSetItem(item) {
    localStorage.setItem(userLocalStorageKey, JSON.stringify(item));
}

export const account = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};